






import {audio as audioText} from "../../utils/audioText"
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import { CHAT_ROLE, CHAT_TYPE } from ".";
import MyImage from "../myImage/myImage.vue";
import MyVideo from "../myVideo/myVideo.vue";
import { utils } from "../../S51WebGLSDK/utils/utils";
import TypeMessageVue from "../TypeMessage/TypeMessage.vue";
import TypeFlowMessageVue from "../TypeFlowMessage/TypeFlowMessage.vue"
import elementResizeDetectorMaker from "element-resize-detector";
import { chatWordToVoice, dialog, headInfoSize, chatToken, translateVoiceToText } from "../../api/api";
import { CHAT_EVNET, CHAT_MSG_TYPE } from "../../S51WebGLSDK/define";
import Loading from 'vux/src/components/loading/index.vue'

import S51WebGLSDK from "../../S51WebGLSDK";
import { getChatFileType,base64ToBlob } from "../../utils/utils";
import { ChatService } from "../../utils/chatService";
import { EventBus,BUS_EVENT } from "../../eventBus";
import S51AudioPlayer from "../../S51AudioPlayer"
import {AudioDriveType} from "../../S51AudioPlayer"
export default {
name: "chatframe",
components: {
InlineLoading,
TypeMessageVue,
TypeFlowMessageVue,
MyVideo,
MyImage,
Loading,
},
props: {
voiceContentList: Array,
appId: String,
imageType: Number, //类型 0：2D  1：3D
actionMap: {},
defaultChatAction: String,









},
data() {
return {
list: [],
chatType: CHAT_TYPE,
chatRole: CHAT_ROLE,
showVideo: false,
videoUrl: "",
showImage: false,
imageUrl: "",
currentPlayID: 0,
clickPlay: false,
playShow: true,
id: 0,
greetContent: {
id: 0,
playState:0 
},
audioMuted:true,
audioPlayers: {},
longPressTimer: null,
pressedItem: null
};
},

mounted() {
console.log('------------mouted appid',this.appId)
this.enableInput=true
EventBus.$on(BUS_EVENT.ENABLE_INPUT, param => {
this.enableInput=param.enable
})
this.initChatService(this.appId)
document.addEventListener('click',()=>{
if(this.audioMuted){
if(this.greetContent.id>0 && !this.greetContent.typeFinish){//打招呼还没打印完成


}
this.audioMuted=false
audioText.muted=false
S51AudioPlayer.setMuted(false)
}

})
console.log("%c⧭", "color: #ffa280", this.imageType);
let param = utils.getUrlParams(window.location.href);
if (param.type == "GPT") {
this.playShow = false;
}
S51AudioPlayer.reset(param.type=='3d' ? AudioDriveType.TYPE_3D:AudioDriveType.TYPE_2D) 

const erd = elementResizeDetectorMaker();

let _this = this;
console.log("chatList", document.getElementById("chatList"));
erd.listenTo(document.getElementById("chatList"), (element) => {
_this.$nextTick(() => {
let scrollEl = _this.$refs.mianscroll;
scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: "smooth" });
scrollEl.addEventListener("scroll", function (e) {

let chatContainer = document.getElementById("chatContainer");
let containerTop = chatContainer.getBoundingClientRect().top;

let greet = document.getElementById('greet')
if (greet) {

if (greet.getBoundingClientRect().bottom - containerTop < 20) {
greet.style.visibility = "hidden";
} else {
greet.style.visibility = "visible";
}
}

_this.list.forEach((item) => {
let chat = document.getElementById("itemref" + item.id);
if (chat) {


if (chat.getBoundingClientRect().bottom - containerTop < 20) {
chat.style.visibility = "hidden";
} else {
chat.style.visibility = "visible";
}
}
});
});
});
S51AudioPlayer.setEventListener((event,data)=>{
if(event=='startLoading'){
console.log('开始加载',data)
if(data.id == this.greetContent.id){ //打招呼开始播放
this.greetContent.loadingVoice = true
this.greetContent.playTextVoiceSatate=false
}
for(let i=0;i<this.list.length;++i){
if(this.list[i].id==data.id){
this.list[i].playTextVoiceSatate=false
this.list[i].clickPlay=true
}
}
this.$forceUpdate()
}
else if(event=='startPlay'){
console.log('开始播放',data)

if(data.id != this.greetContent.id){ //打招呼开始播放
this.greetContent.playTextVoiceSatate = false
}
for(let i=0;i<this.list.length;++i){
if(this.list[i].id!=data.id){
this.list[i].playTextVoiceSatate=false
}
}

if(data.id == this.greetContent.id){ //打招呼开始播放
this.greetContent.playTextVoiceSatate = true
this.greetContent.loadingVoice=false
}
else{
for(let i=0;i<this.list.length;++i){
if(this.list[i].id==data.id){
this.list[i].playTextVoiceSatate=true
this.list[i].clickPlay=false
}
}
}
this.$forceUpdate()
}
else if(event=='endPlay'){
console.log('播放结束',data)
if(data.id == this.greetContent.id){ //打招呼开始播放
this.greetContent.playTextVoiceSatate = false
this.greetContent.loadingVoice=false
}
else{
for(let i=0;i<this.list.length;++i){
if(this.list[i].id==data.id){
this.list[i].playTextVoiceSatate=false
}
}
}
this.$forceUpdate()
}
})
});

},
beforeDestroy() { },
methods: {

startLongPress(event, item) {

if (this.longPressTimer) {
clearTimeout(this.longPressTimer);
}

this.pressedItem = item;

const longPressDuration = 500;

this.longPressTimer = setTimeout(() => {

this.$set(item, 'showTranslateBtn', true);
}, longPressDuration);
},

cancelLongPress() {

if (this.longPressTimer) {
clearTimeout(this.longPressTimer);
this.longPressTimer = null;
}
this.pressedItem = null;
},

translateVoice(item) {

this.$set(item, 'showTranslateBtn', false);
if(item.translateText != ''){
if(item.translateShowStatus){
this.$set(item, 'translateShowStatus', false);
}else{
this.$set(item, 'translateShowStatus', true);
}
}else{
this.$vux.loading.show({
text: '转换中...',
position:'absolute'
})
let options = {
voice: item.voiceHttpUrl,
app_id: this.appId,
}
translateVoiceToText(options)
.then((res) => {
this.$vux.loading.hide();
if (res.code == 200) {
this.$set(item, 'translateShowStatus', true);
this.$set(item, 'translateText', res.data.word);
}
})
.finally(() => {
this.$vux.loading.hide();
});
}
},
playAudio(id, item){

if (!this.audioPlayers) {
this.audioPlayers = {};
}

if (!this.audioPlayers[id]) {
this.audioPlayers[id] = new Audio();

this.audioPlayers[id].addEventListener('ended', () => {
console.log('音频播放完成');

this.audioPlayers[id].currentTime = 0;
this.$set(item, 'rightPlayStatus', false);
});
}

const audio = this.audioPlayers[id];


if (!audio.paused) {
audio.pause();
audio.currentTime = 0;
this.$set(item, 'rightPlayStatus', false);
console.log('音频已暂停并重置');
return;
}


if (item.voiceHttpUrl && audio.src !== item.voiceHttpUrl) {
audio.src = item.voiceHttpUrl;
}
this.$set(item, 'rightPlayStatus', true);
audio.play();
},
onClickQuestion(data){
console.log('点击了问题:',data)
this.flowChat(CHAT_TYPE.TEXT, data,0)
},
/**
* 流式聊天
*/
initChatService(appId){
console.log('init chat service',appId)
if(appId && appId.length){
if(!this.lastAppId || this.lastAppId!=appId){
console.log('appid change',appId)
this.lastAppId=appId
chatToken({
app_id:appId,
type:this.imageType  
}).then((d)=>{
if(this.chatService){
this.chatService.disconnect()
this.chatService=null
}
this.chatServiceToken = d.data.token
this.chatService = new ChatService(appId,d.data.token).connect()

},(e)=>{
console.error('获取长连接token失败')
})
}

}
},
/**
* 播放打招呼
*/
onPlayGreetVoice(){

if(!this.enableInput){
return
}
if(this.greetContent.playTextVoiceSatate){
S51AudioPlayer.pause()
this.greetContent.playTextVoiceSatate=false
this.$forceUpdate()
return
}
if(this.greetContent.helloAudio &&  (!this.greetContent.preName || this.greetContent.name==this.greetContent.preName )){
S51AudioPlayer.reset()
S51AudioPlayer.addAudio(this.greetContent.helloAudio,this.greetContent.id,true) 
}
else{
this.greetContent.preName =  this.greetContent.name
let name = this.greetContent.name;
this.$set(this.greetContent,'loadingVoice',true)
chatWordToVoice(name, this.appId)
.then((res) => {
if (res.code == 200) {
this.greetContent.helloAudio = res.data.audio;
this.greetContent.viseme = res.data.viseme;
this.greetContent.duration = res.data.duration;
S51AudioPlayer.reset()
S51AudioPlayer.addAudio(this.greetContent.helloAudio,this.greetContent.id,true)
}
})
.finally(() => {
this.$set(this.greetContent,'loadingVoice',false)
});
}


},

onEditText() {
this.$emit("informEditModal", { open: true, text: this.greetContent.name })
},

onPlayTextVoice(item) {
if (this.clickPlay) return;
if(!this.enableInput){ //流式聊天正在接受数据
return
}
if(item.playTextVoiceSatate){
S51AudioPlayer.pause()
item.playTextVoiceSatate=false
this.$forceUpdate()

return
}
this.id = item.id;
this.stopAllTyping();
if(item.msgQueue.length){
S51AudioPlayer.reset()
for(let i=0;i<item.msgQueue.length;++i){
if(item.msgQueue[i].flag == 'ing' && item.msgQueue[i].audio && item.msgQueue[i].audio.length>0){
S51AudioPlayer.addAudio(item.msgQueue[i].audio,item.id)
}
else if(item.msgQueue[i].flag == 'end'){
S51AudioPlayer.addAudio(null,item.id,true) 
}

}
}
































},

onTextShowAccomplish(e) {
console.log("%c⧭", "color: #00bf00", e);
console.log('0000000')
this.list.forEach((item) => {
console.log('11111111')
if (item.id == e.itemID) {
item.disPlay = true;
console.log('------打字结束',item);

if (item.extFile) {
this.addExtFileMsg(item.extFile)
}
}
});

S51WebGLSDK.playIdleAction();
this.stopedAcion=Date.now()
this.$forceUpdate();
console.log("%c⧭", "color: #0088cc", this.list);
},
stopNowVoice() {
S51WebGLSDK.stopNowVoice();
audioText.pause();
if(this.greetContent.speed>0){
this.greetContent.speed=0
this.greetContent.typeFinish=true
this.greetContent.disPlay=true
}
},

openFile(url) {
console.log("打开文档", url);
this.$wechat.miniProgram.navigateTo({
url: `../documentView/documentView?url=${encodeURIComponent(url)}`,
success: function () {
console.log("跳转成功");
},
});
},
onLookVideo(url) {
this.videoUrl = url;
this.showVideo = true;
this.stopNowVoice()
},
onLookImage(url) {
this.imageUrl = url;
this.showImage = true;
},
async addExtFileMsg(annex) {
console.log('添加文件:',annex)

let type = getChatFileType(annex);
if (type) {
if (type == CHAT_TYPE.IMG) {
this.list.push({
type: type,
differentiate: CHAT_ROLE.ROBOT,
id: "ext_" + Date.now(),
app_id: this.appId,
imageUrl: annex,
});
} else if (type == CHAT_TYPE.VIDEO) {
this.list.push({
type: type,
differentiate: CHAT_ROLE.ROBOT,
id: "ext_" + Date.now(),
app_id: this.appId,
videoUrl: annex,
videoCover: annex + "?vframe/jpg/offset/2/w/480", //获取封面图
});
} else if (type == CHAT_TYPE.FILE) {

try {
var size = await headInfoSize(annex);
size = (size / (1024 * 1024)).toFixed(2);
} catch (e) {
console.log(e);
}

let fileName = "附件";
let arr = annex.split("/");
if (arr.length > 0) {
fileName = arr[arr.length - 1];
}
this.list.push({
type: type,
differentiate: CHAT_ROLE.ROBOT,
id: "ext_" + Date.now(),
app_id: this.appId,
name: fileName,
size: size || 0,
fileUrl: annex,
});
}
}
},
chat(type, message,cardID) {
console.log("聊天:", type, message);
return this.flowChat(type, message,cardID)
},

addRobotMessage(helloWorld, voiceUrl, voiceViseme, action) {

let chatInfo = {
differentiate: CHAT_ROLE.ROBOT,
id: Date.now(),
app_id: this.appId,
playAction: action,
};


chatInfo.type = CHAT_TYPE.TEXT;
(chatInfo.name = helloWorld), (chatInfo.speed = 100); 
this.list.push(chatInfo);
console.log("say hello ", chatInfo, this.list);
if (this.imageType == 1 && action && action.length > 0) {

S51WebGLSDK.playAction(action);
}
this.$emit("onChatListChange", this.list);
},
stopAllTyping() {

this.greetContent.speed=0
for (let i = 0; i < this.list.length; ++i) {
if (
this.list[i].differentiate == CHAT_ROLE.ROBOT &&
this.list[i].type == CHAT_TYPE.TEXT
) {
this.list[i].speed = 0;
this.list[i].disPlay = true;
}
}
},
clearChat() {
this.list = [];
this.greetContent={
id:0
}
this.stopAllTyping()
this.stopNowVoice()
},
onTextShowGreetFinish(e){ //打招呼文字显示结束
console.log('greet type finish',e.itemID , this.greetContent.id)
if(e.itemID == this.greetContent.id){
this.greetContent.disPlay = true;

if (this.greetContent.extFile) {
this.addExtFileMsg(this.greetContent.extFile)
}
this.$set(this.greetContent,'typeFinish',true)
}
S51WebGLSDK.playIdleAction()
},

playHello(){
if(this.greetContent.id==0){
return
}

if (this.imageType == 1) {

S51WebGLSDK.setAudioMuted(false)
}
else {
console.log('开始播放语音',this.greetContent.helloAudio)
audioText.src = this.greetContent.helloAudio;
audioText.autoplay=false
audioText.preload='none'
let startPlay=()=>{
audioText.removeEventListener('canplaythrough',startPlay)
audioText.currentTime = this.$refs.greetMessage.getCurShowLength()*this.greetContent.speed/1000
console.log('可以完整播放音频了',audioText.currentTime)
audioText.addEventListener('seeked',()=>{
audioText.muted=false
audioText.play()
})

}
audioText.addEventListener('canplaythrough',startPlay)
audioText.muted=true
audioText.load()
}
},
/**
* 打招呼
*/
sayHello(helloWord, helloAudio, helloVisem, action, duration, isMyself) {
console.log('say hello', helloWord, this.imageType)

S51AudioPlayer.addAudio(helloAudio,this.greetContent.id,true)
if(this.imageType == 1){ //3D
this.greetContent.playAction && this.greetContent.playAction.length > 0 && S51WebGLSDK.playAction(this.greetContent.playAction);
}
this.greetContent = {
name: helloWord,
id: Date.now(),
speed:(duration > 0 ?  (duration*1000)/helloWord.length   : 0) ,
isMyself: isMyself,
helloAudio:helloAudio,
helloVisem:helloVisem,
playAction:action,
duration:duration
}
},
updateHelloWord(hellWord){
console.log('更新打招呼内容',hellWord)
this.greetContent.preName = this.greetContent.name
this.$set(this.greetContent, 'name',hellWord);
},
flowChat(type, message,cardID) {
console.log('message', message);

return new Promise((resolve, reject) => {
resolve({
data:{

}
})
let messageText = null;
let messageVoice = null;
this.stopAllTyping(); 
this.stopNowVoice();

for(let i=0;i<this.list.length;++i){
this.list[i].playTextVoiceSatate = false
}
EventBus.$emit(BUS_EVENT.ENABLE_INPUT,{enable:false})
switch (type) {
case CHAT_TYPE.TEXT:
messageText = message;
this.list.push({
type: CHAT_TYPE.TEXT,
differentiate: CHAT_ROLE.USER,
id: Date.now(),
name: message,
app_id: this.appId,
});
break;
case CHAT_TYPE.VOICE:
messageVoice = message;
this.list.push({
type: CHAT_TYPE.VOICE,
differentiate: CHAT_ROLE.USER,
id: Date.now(),
voiceUrl: messageVoice.voiceUrl,
voiceHttpUrl: messageVoice.voiceHttpUrl,
app_id: this.appId,
duration: Math.floor(messageVoice.duration),
rightPlayStatus: false,
showTranslateBtn: false,
translateText: '',
translateShowStatus: false
});
break;
}
this.$emit("onChatListChange", this.list);
let self =this
this.chatService.ask(1,type==CHAT_TYPE.VOICE?messageVoice.voiceHttpUrl:messageText,type,null,(msg)=>{
console.log('flow chat',msg)
if(msg.m && msg.m.length>0){
console.error('聊天失败：',msg.m)

EventBus.$emit(BUS_EVENT.ENABLE_INPUT,{enable:true})
return
}
if( msg.f=='start'){
let chatInfo = {
differentiate: CHAT_ROLE.ROBOT,
id: Date.now(),
app_id: self.appId,
flowText:true,
type : CHAT_TYPE.TEXT,
audioText:audioText,
name : '',
msgQueue:[{
txt:'',
file:'',
audio:'',
viseme:'',
flag:'start'
}],
};
self.currentChatInfo = chatInfo
self.list.push(chatInfo);

console.log(' answer start input')
self.$emit("onChatListChange", self.list);
S51AudioPlayer.reset()
}
else if(msg.f=='ing' && self.currentChatInfo){
let audio=''
if(msg.a && msg.a.length>0){
audio =  msg.a[0]
if(audio.indexOf('http')==0){ //http直接按照http文件播放

}
else{
audio = 'data:audio/mpeg;base64,'+audio
}


}
if(msg.r.data.f && msg.r.data.f.length){
self.currentChatInfo.extFile = msg.r.data.f
}
self.currentChatInfo.msgQueue.push({
txt:msg.r.data.r,
file:msg.r.data.f,
audio:audio!=''?audio:null,
viseme:msg.v,
flag:'ing'
})
S51AudioPlayer.addAudio(audio,self.currentChatInfo.id)
if(self.currentChatInfo.msgQueue.length==2){ //第一个ing 开始播放动作


let actionUrl =
self.defaultChatAction && self.defaultChatAction.length > 0
? self.actionMap[self.defaultChatAction]
: "";
if (self.actionMap && msg.r.data.ba && self.actionMap[msg.r.data.ba]) {
actionUrl = self.actionMap[msg.r.data.ba];
console.log("使用指定动作", actionUrl);
}
console.log('------------查询动作',actionUrl,self.actionMap,msg.r.data.ba)
if (self.imageType == 1) {

actionUrl &&
actionUrl.length > 0 &&
S51WebGLSDK.playAction(actionUrl);
}
self.currentChatInfo.playAction = actionUrl

}


}
else if(msg.f=='end' && self.currentChatInfo){ //消息结束
self.currentChatInfo.name = msg.r
self.currentChatInfo.msgQueue.push({
txt:'',
file:'',
audio:'',
viseme:'',
flag:'end'
})
S51AudioPlayer.addAudio(null,self.currentChatInfo.id,true)
self.currentChatInfo.flag='end'
self.currentChatInfo=null

}

})
});
},
},
watch: {
appId(app_id){
this.initChatService(app_id)
}
},
};



// WEBPACK FOOTER //
// ./src/myComponents/Chatframe/Chatframe.vue